import { render, staticRenderFns } from "./BehaviorProfile.vue?vue&type=template&id=3ce32684&scoped=true&"
import script from "./BehaviorProfile.vue?vue&type=script&lang=js&"
export * from "./BehaviorProfile.vue?vue&type=script&lang=js&"
import style0 from "./BehaviorProfile.vue?vue&type=style&index=0&id=3ce32684&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce32684",
  null
  
)

export default component.exports